import React, { useEffect, useRef } from "react";
import $ from "jquery";
import "select2/dist/css/select2.min.css";
import "select2";
import "./content-hub-upload.css";
import ContentTable from "./ContentTable";
import NoOfDownloads from "./NoOfDownloads";
import AssetsUploadModal from "./AssetsUploadModal";
import ContentFilterPopup from "./ContentFilterPopup";
const ContentHubUpload = () => {

  const downloadsData = [
    {
      date: "15-Jan-2025",
      employeeId: "0001",
      downloadBy: {
        initials: "SD",
        name: "Sandeep Dubey",
        bgColor: "rgb(0, 132, 103)",
        color: "white",
      },
      projectCode: "Project 090_D",
    },
    {
      date: "15-Jan-2025",
      employeeId: "0002",
      downloadBy: {
        initials: "ST",
        name: "Sarah Thompson",
        bgColor: "rgb(23, 172, 0)",
        color: "white",
      },
      projectCode: "Project 090_D",
    },
    // Add more rows as needed
  ];


  return (
    <div> 
    {/*gy-4 mt-1*/}
    <div className="row">
      <div className="col-xl-12 col-xxl-12">
        <div className="card h-100">
          <div className="card-body p-24">
            <h2 className="d-flex align-items-center font-24 fw-semibold gap-4 mb-16">
              <button>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 32 32"
                  width={30}
                  height={30}
                >
                  <g data-name="20-Arrow Left">
                    <path
                      fill="#0073ea"
                      d="M16 0a16 16 0 1 0 16 16A16 16 0 0 0 16 0zm0 30a14 14 0 1 1 14-14 14 14 0 0 1-14 14z"
                    />
                    <path
                      fill="#0073ea"
                      d="m8.41 15 5.29-5.29-1.41-1.42-7 7a1 1 0 0 0 0 1.41l7 7 1.41-1.41L8.41 17H27v-2z"
                    />
                  </g>
                </svg>
              </button>{" "}
              Content Hub Upload
            </h2>
            <ul className="d-flex align-items-center gap-2">
              <li className="fw-medium">
                <a
                  href="index-2.html"
                  className="d-flex align-items-center gap-1 hover-text-primary"
                >
                  <iconify-icon
                    icon="solar:home-smile-angle-outline"
                    className="text-lg icon"
                  ></iconify-icon>
                  Special Access
                </a>
              </li>
              <li>-</li>
              <li className="fw-medium">My Clients </li>
              <li>-</li>
              <li className="fw-medium">View Report </li>
            </ul>
            <div className="d-flex align-items-center gap-2 py-16">
              {/* Search start */}
              <div className="w-25 search">
                <span className="position-absolute line-height-1 me-12 searchBtn top-50 translate-middle-y">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="1em"
                    height="1em"
                    viewBox="0 0 512 512"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      strokeMiterlimit={10}
                      strokeWidth={32}
                      d="M221.09 64a157.09 157.09 0 1 0 157.09 157.09A157.1 157.1 0 0 0 221.09 64Z"
                    ></path>
                    <path
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeMiterlimit={10}
                      strokeWidth={32}
                      d="M338.29 338.29L448 448"
                    ></path>
                  </svg>
                </span>
                <input
                  type="text"
                  className="form-control radius-8"
                  id="search"
                  placeholder="Search"
                />
              </div>
              {/* Search End */}
              {/* Filter btn start */}
              <div className="FilterBtn">
                <button
                  type="button"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#filterRightPopup"
                  aria-controls="filterRightPopup"
                  className="d-flex btn btn-outline-primary-600 align-items-center gap-2 grbtn heightAllBtnSet44 px-20 py-9 radius-8"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="2em"
                    height="1.5em"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="currentColor"
                      d="M6 13h12v-2H6M3 6v2h18V6M10 18h4v-2h-4z"
                    />
                  </svg>{" "}
                  Filter
                </button>
              </div>
              {/* Filter btn end */}
            </div>
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-16 mt-6">
              <h6
                className="d-flex align-items-center text-lg fw-semibold gap-2 mb-0"
                style={{ color: "#A038E0" }}
              >
                <svg
                  width={30}
                  height={26}
                  viewBox="0 0 30 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M29.3939 6.08085L15.3939 0.0808499C15.2681 0.0269499 15.1368 0 15 0C14.8632 0 14.7319 0.0269499 14.6061 0.0808599L0.606087 6.08088C0.488077 6.13145 0.383687 6.20213 0.292897 6.29292C0.202117 6.3837 0.131437 6.4881 0.0808567 6.60611C0.0286267 6.72799 0.00169666 6.85524 7.66558e-05 6.98783C-0.00153534 7.1204 0.0222767 7.2483 0.0715267 7.3714C0.120777 7.4945 0.191717 7.6036 0.284337 7.6985C0.376947 7.7934 0.484207 7.8669 0.606087 7.9192L5.46159 10.0001L0.606087 12.081C0.488077 12.1316 0.383687 12.2023 0.292897 12.2931C0.202117 12.3838 0.131437 12.4882 0.0808667 12.6062C0.0286267 12.7281 0.00169667 12.8554 8.66694e-05 12.988C-0.00153233 13.1206 0.0222867 13.2484 0.0715367 13.3716C0.120787 13.4947 0.191717 13.6037 0.284337 13.6986C0.376957 13.7935 0.484207 13.8671 0.606097 13.9193L5.46143 16.0002L0.606087 18.081C0.488077 18.1316 0.383687 18.2023 0.292897 18.2931C0.202117 18.3838 0.131437 18.4882 0.0808667 18.6063C0.0286267 18.7281 0.00169667 18.8554 8.66694e-05 18.988C-0.00153233 19.1206 0.0222867 19.2484 0.0715367 19.3716C0.120787 19.4947 0.191717 19.6037 0.284337 19.6986C0.376957 19.7935 0.484207 19.8671 0.606097 19.9193L14.6061 25.9193C14.7319 25.9732 14.8632 26.0001 15 26.0001C15.1369 26.0001 15.2682 25.9732 15.394 25.9193L29.3939 19.9193C29.5119 19.8687 29.6163 19.798 29.7071 19.7072C29.7979 19.6165 29.8686 19.5121 29.9192 19.3941C30.0279 19.1402 30.031 18.8851 29.9285 18.6287C29.8259 18.3724 29.6477 18.1898 29.3939 18.081L24.5386 16.0001L29.3939 13.9193C29.5119 13.8687 29.6163 13.798 29.7071 13.7072C29.7979 13.6165 29.8686 13.5121 29.9192 13.3941C30.0279 13.1402 30.031 12.8851 29.9285 12.6287C29.8259 12.3724 29.6477 12.1898 29.3939 12.081L24.5384 10.0001L29.3939 7.9191C29.5119 7.8686 29.6163 7.7979 29.7071 7.7071C29.7979 7.6163 29.8686 7.5119 29.9191 7.3939C30.0279 7.1401 30.031 6.88499 29.9285 6.6286C29.8259 6.37221 29.6477 6.18962 29.3939 6.08085ZM21.9998 11.088L15.394 13.9191C15.2682 13.973 15.1369 14 15 14C14.8632 14 14.7319 13.973 14.6061 13.9191L8.00019 11.088L3.53861 13.0002L15 17.9122L26.4614 13.0001L21.9998 11.088ZM3.53861 19.0002L8.00002 17.0881L14.6061 19.9193C14.7319 19.9732 14.8632 20.0001 15 20.0001C15.1369 20.0001 15.2682 19.9732 15.394 19.9193L22 17.0881L26.4614 19.0001L15 23.9122L3.53861 19.0002Z"
                    fill="#A038E0"
                  />
                </svg>
                Assets
              </h6>
              <button
                type="button"
                className="d-flex btn btn-primary align-items-center gap-2"
                data-bs-toggle="modal"
                data-bs-target="#assetsUpload"
              >
                <svg
                  width={14}
                  height={14}
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.08301 7.91665H1.49967C1.23995 7.91665 1.02224 7.8288 0.846549 7.6531C0.670855 7.47741 0.583008 7.2597 0.583008 6.99998C0.583008 6.74026 0.670855 6.52255 0.846549 6.34685C1.02224 6.17116 1.23995 6.08331 1.49967 6.08331H6.08301V1.49998C6.08301 1.24026 6.17085 1.02255 6.34655 0.846855C6.52224 0.67116 6.73995 0.583313 6.99967 0.583313C7.2594 0.583313 7.4771 0.67116 7.6528 0.846855C7.82849 1.02255 7.91634 1.24026 7.91634 1.49998V6.08331H12.4997C12.7594 6.08331 12.9771 6.17116 13.1528 6.34685C13.3285 6.52255 13.4163 6.74026 13.4163 6.99998C13.4163 7.2597 13.3285 7.47741 13.1528 7.6531C12.9771 7.8288 12.7594 7.91665 12.4997 7.91665H7.91634V12.5C7.91634 12.7597 7.82849 12.9774 7.6528 13.1531C7.4771 13.3288 7.2594 13.4166 6.99967 13.4166C6.73995 13.4166 6.52224 13.3288 6.34655 13.1531C6.17085 12.9774 6.08301 12.7597 6.08301 12.5V7.91665Z"
                    fill="white"
                  />
                </svg>
                Upload Assets
              </button>
            </div>
            <ContentTable />
          </div>
        </div>
      </div>
    </div>
   
  {/* === Start Filter Popup Sec ===  */}
 <ContentFilterPopup />
  {/* === End Filter Popup Sec ===  */}
  {/* start Media Assets Upload  */}
  {/* Modal */}
  <AssetsUploadModal />
  {/* End Media Assets Upload  */}
  {/* start No.of Downloads Popup  */}
   
  <NoOfDownloads downloadsData={downloadsData} />
    </div>
  )
}

export default ContentHubUpload
